/**
 * Yükleme öncesi görsel küçültme.
 *
 * Neden: Sunucudaki görsellerin bir kısmı 10-20 MB (telefon/fotoğraf makinesi
 * çıktısı). Site bunları wsrv.nl CDN'i üzerinden küçülterek sunuyor, ama CDN
 * küçültmeden önce kaynağı indirmek zorunda kaldığı için bu dosyalarda zaman
 * aşımına uğruyor ve görseller sitede hiç görünmüyordu.
 *
 * Çözüm: Dosya sunucuya gitmeden tarayıcıda yeniden boyutlandırılıyor.
 * 1600px, retina ekranlar dahil sitedeki her kullanım için fazlasıyla yeterli.
 */

export const MAX_EDGE = 1600;
export const JPEG_QUALITY = 0.82;

/** Küçültme gerekmiyorsa dosyayı olduğu gibi döndürür. */
export const downscaleImage = (file) =>
  new Promise((resolve) => {
    // Görsel olmayan dosyalara (PDF, video) dokunma.
    if (!file || !file.type || !file.type.startsWith('image/')) return resolve(file);
    // GIF'lerde animasyon kaybolmasın.
    if (file.type === 'image/gif') return resolve(file);
    // SVG vektörel, yeniden boyutlandırmak anlamsız.
    if (file.type === 'image/svg+xml') return resolve(file);

    const url = URL.createObjectURL(file);
    const img = new Image();

    img.onload = () => {
      const { width, height } = img;
      const scale = Math.min(1, MAX_EDGE / Math.max(width, height));

      // Zaten küçük ve makul boyuttaysa dokunma.
      if (scale === 1 && file.size <= 600 * 1024) {
        URL.revokeObjectURL(url);
        return resolve(file);
      }

      const canvas = document.createElement('canvas');
      canvas.width = Math.round(width * scale);
      canvas.height = Math.round(height * scale);
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(url);

      canvas.toBlob(
        (blob) => resolve(blob && blob.size < file.size ? blob : file),
        'image/jpeg',
        JPEG_QUALITY
      );
    };

    // Okunamayan dosyada orijinali gönder; yükleme hiç olmasın demeyelim.
    img.onerror = () => { URL.revokeObjectURL(url); resolve(file); };

    img.src = url;
  });

/** Küçültülen dosya JPEG'e döndüğü için uzantıyı da düzeltir. */
export const resizedFileName = (blob, originalName) =>
  blob && blob.type === 'image/jpeg' && !/\.jpe?g$/i.test(originalName || '')
    ? String(originalName || 'image').replace(/\.[^.]+$/, '') + '.jpg'
    : (originalName || 'image');

/**
 * react-dropzone-uploader için hazır getUploadParams üreticisi.
 * (Kütüphane getUploadParams'ın Promise döndürmesini destekler.)
 *
 *   const getUploadParams = makeUploadParams(UPLOAD_URL);
 */
export const makeUploadParams = (uploadUrl, fieldName = 'dataFile') => async ({ file }) => {
  const blob = await downscaleImage(file);
  const body = new FormData();
  body.append(fieldName, blob, resizedFileName(blob, file.name));
  return { url: uploadUrl, body };
};
